import script from "./BookingProcessApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./BookingProcessApp.vue?vue&type=script&lang=ts&setup=true"

import "./BookingProcessApp.vue?vue&type=style&index=0&id=bec3220a&lang=scss"
import "./BookingProcessApp.vue?vue&type=style&index=1&id=bec3220a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3010703901/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bec3220a"]])

export default __exports__